// extracted by mini-css-extract-plugin
export default {"btnStyle":"share_btnStyle__yk4Bp"};